import { render, staticRenderFns } from "./MaterialForm.vue?vue&type=template&id=38fabf2e&scoped=true"
import script from "./MaterialForm.vue?vue&type=script&lang=js"
export * from "./MaterialForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fabf2e",
  null
  
)

export default component.exports